// extracted by mini-css-extract-plugin
export default {"mCard":"MF-z","image":"NF-z","imageNoBackground":"OF-z","imageHasCategory":"PF-z","fullWidth":"QF-z"};